import { MedmalStepService } from './../../../Services/MedmalStepService';
import { MedmalBindMdl } from './../../../Models/MedmalBindMdl';
import { Subscription } from 'rxjs';
import { LanguageService } from './../../../Services/languageService';
import { restURL } from './../../../Models/restURL';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { MedmalProposal, MedmalstatusMdl } from '../../../Models/MedmalProposal';
import { motorProposalService } from '../../../Services/motorProposalService';
import Swal from 'sweetalert2';
import swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { EncryptionService } from '../../../Services/EncryptionService';
import { APIService } from '../../../Services/api.service';

@Component({
    selector: 'MedmalInsuredInfo',
    templateUrl: './MedmalInsuredInfo.html',
    styleUrls: ['./MedmalInsuredInfo.css']
  })
export class MedmalInsuredInfo
{
  public  httpOptions = {headers: new HttpHeaders({'Content-Type':  'application/json'})}; 
  public isShowLoading:boolean=false;
  public LngSubscription:Subscription;
  public medmalBindObj:MedmalBindMdl=new MedmalBindMdl(); 
  public proposalObj:MedmalProposal=new MedmalProposal();
  public medmalStatusMdl:MedmalstatusMdl=new MedmalstatusMdl();
  public Lng:string;
  public isError:boolean;
  public isSubmitted:boolean;
  public agreeTerms:boolean;
  public agreeKYC: boolean;
  public CityName: string;
  public agreeNatAdd: boolean;
  public TermsURl:string;
  @ViewChild('txtIBAN2') txtIBAN2Element: ElementRef;
  @ViewChild('txtIBAN3') txtIBAN3Element: ElementRef;
  @ViewChild('txtIBAN4') txtIBAN4Element: ElementRef;
  @ViewChild('txtIBAN5') txtIBAN5Element: ElementRef;
  @ViewChild('txtIBAN6') txtIBAN6Element: ElementRef;
  public ShowHigherPositionFeild: boolean = false;
  constructor( private APISer: APIService, private translate: TranslateService,private EncriptService: EncryptionService,private router: Router,private http:HttpClient,public url:restURL,private lngService:LanguageService,private medStepService: MedmalStepService)
  {
    
     // this.medStepService.setStepNum(2);
     this.LngSubscription=this.lngService.grtLng().subscribe(lng=>{this.Lng=lng});
     this.isError=false;
     this.isSubmitted=false;
     this.agreeTerms=false;
     this.TermsURl =url.DocumentURL+"termsandcondition_medmal.pdf"
    // this.isError=false;
     if(sessionStorage.getItem("Language")!=null)
     {
       let Lng :any=sessionStorage.getItem("Language");
       this.Lng=Lng;
     }
     else
     {
      this.Lng="en";
     }
     if(sessionStorage.getItem("medmalProposalObj")!=null)
     {
    let proposal:any=sessionStorage.getItem("medmalProposalObj")
     if(proposal)this.proposalObj = JSON.parse(this.EncriptService.DecriptObject(proposal));
     let medmalBind:any=sessionStorage.getItem("medmalBindObj");
     if(medmalBind)this.medmalBindObj = JSON.parse(this.EncriptService.DecriptObject(medmalBind));
     if (this.proposalObj.ICity != "" && this.proposalObj.ICity != null) {
       
       this.CityName = this.medmalBindObj.cityList.filter(t => t.CityCode == Number(this.proposalObj.ICity))[0].CityNameEn;
     }
 
     }
     else
     {
      this.router.navigate(['NewDashboard/MedmalNewProposal']);
     }
     let UseriD:any=sessionStorage.getItem("UserId")
     this.medmalBindObj.proposalObj.UserID= JSON.parse(this.EncriptService.DecriptObject(UseriD));
     this.proposalObj.UserID= JSON.parse(this.EncriptService.DecriptObject(UseriD));
  }


 
  iban1Changed(event:any) {
   
    if (event != "" && event != undefined && event != null) {
     
       if(event.length==2)
       {
 
        setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
      }      
    }
  }

  

  iban2Changed(event:any) {
    if (event != "" && event != undefined && event != null) {
     
       if(event.length==4)
       {
        let bankCode: string = event.substring(0, 2)
        this.proposalObj.BankCode = bankCode;
        if(this.medmalBindObj.bankList.filter(t=>t.BankCode==bankCode).length>0)
        {
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else
        {
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
        }

        
      }      
    }
  }


  iban3Changed(event:any) {
    if (event != "" && event != undefined && event != null) {
   
       if(event.length==4)
       {
        setTimeout(() => this.txtIBAN4Element.nativeElement.focus(), 0);
      }      
    }
  }

  iban4Changed(event:any) {
    if (event != "" && event != undefined && event != null) {
     
       if(event.length==4)
       {
        setTimeout(() => this.txtIBAN5Element.nativeElement.focus(), 0);
      }      
    }
  }

  iban5Changed(event:any) {
    if (event != "" && event != undefined && event != null) {
    
       if(event.length==4)
       {
        setTimeout(() => this.txtIBAN6Element.nativeElement.focus(), 0);
      }      
    }
  }


  setBankCode(IBAN:any) {
    let bankCode: string = IBAN.substring(0, 2)
    this.proposalObj.BankCode = bankCode;
    if (IBAN != "" && IBAN != undefined && IBAN != null) {
      if(IBAN.length==4){
        let bankCode: string = IBAN.substring(0, 2);
        if(this.medmalBindObj.bankList.filter(t=>t.BankCode==bankCode).length>0){
          this.proposalObj.BankCode = bankCode;
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else{
          this.proposalObj.BankCode = "";
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
        }
      }      
    }
  }

  GoNext(val:any){
    this.isSubmitted=true;
    if(!this.agreeTerms){
      swal(this.translate.instant("Please agree terms and conditions"));
      return;
    }
    if(!this.agreeKYC){
      swal(this.translate.instant("Please check KYC Details"));
      return;
    }
    if(!this.agreeNatAdd){
      swal(this.translate.instant("Please agree National Address Declaration"));
      return;
    }
    if(val){
      this.proposalObj.HigherPositionCode = Number(this.proposalObj.HigherPositionCode);
      this.proposalObj.IBAN = this.proposalObj.IBAN1 + this.proposalObj.IBAN2 + this.proposalObj.IBAN3 + this.proposalObj.IBAN4 + this.proposalObj.IBAN5 + this.proposalObj.IBAN6;
      this.proposalObj.IBAN="SA"+this.proposalObj.IBAN;
      if(this.proposalObj.IBAN1==null || this.proposalObj.IBAN2==null||this.proposalObj.IBAN3==null||this.proposalObj.IBAN4==null||this.proposalObj.IBAN5==null||this.proposalObj.IBAN6==null || this.proposalObj.IBAN.length!=24){
          this.Lng=="en"? Swal("IBAN Number must be 24 digits"):Swal("يجب أن يكون رقم الايبان من 24 رقماً");
      }
      else if(this.proposalObj.BankCode.length == 0 || this.proposalObj.BankCode == null || this.proposalObj.BankCode == "00"){
        this.Lng == "ar" ? Swal("اسم البنك غير صحيح ") : Swal("Invalid Bank Name");
        return;
      }
      else{
        this.ValidateIBAN();
        //sessionStorage.setItem("medmalProposalObj",JSON.stringify(this.proposalObj));
        sessionStorage.setItem("medmalProposalObj", this.EncriptService.EncriptObject(JSON.stringify(this.proposalObj)));


        this.router.navigate(['NewDashboard/MedmalReviewConfirm']);
      }
    }
  }

  async ValidateIBAN() {
    this.isShowLoading = true;
    var APIRes = await this.APISer.ConnectAPI("/LimraMedmal/ValidateMedmalIBAN", this.proposalObj)
    this.isShowLoading = false;
    var APIStatus = APIRes[0]
    if (APIStatus.StatusCode == "F") {
      Swal(APIStatus.StatusDesc, "", "error")
      return;
    }
    let res = APIRes[1];
    if (APIRes[1].st.StatusCode == "F") {
      this.Lng == "en" ? Swal(APIRes[1].st.StatusDesc) : Swal(APIRes[1].st.StatusDescAr);
      return;
    }
    else{
      sessionStorage.setItem("medmalProposalObj", this.EncriptService.EncriptObject(JSON.stringify(this.proposalObj)));
      this.router.navigate(['NewDashboard/MedmalReviewConfirm']);
    }
  }
 
  
  IsHigherPosition(val:any){
    if(val=="true"){
      this.proposalObj.IsHigherPosition = true;
      this.ShowHigherPositionFeild = true;
    }else{
      this.proposalObj.IsHigherPosition = false;
      this.proposalObj.HigherPositionCode = 0;
      this.ShowHigherPositionFeild = false;
      
    }
  }

  ValidateSpecialCharacters(event:any) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k>1500 && k<1650) || k == 8 || k == 32);
  }

  GoPrev(){
    this.router.navigate(['NewDashboard/MedmalNewProposalConfirm']);
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MedmalPortal/MedmalInsuredInfo/MedmalInsuredInfo.ts